export function isEmpty(data: any, name: string) {
    const isDataEmpty = !Object.keys(data || {}).length
    const isUndefined = typeof data?.[name] === 'undefined'

    return !data || isDataEmpty || isUndefined
}
